import React from 'react';
import { useShowContext } from 'framework/show';
import { useArtifactService, useArtifactDownloadHelper } from 'domain/shared/artifact';
import { useAsyncValue } from 'framework/utils';
import { FileName } from 'framework/documentStorage';
import { DownloadIcon } from 'framework/ui/mui-builder';
import { Box } from '@mui/material';

interface AttachmentsListFieldProps {
  value?: string[];
  label?: string;
  isDownloadAvailable?: boolean;
  isOneArtifact?: boolean;
  width?: number;
}

const CandidateResumeBadge: React.FC<AttachmentsListFieldProps> = ({
  value: inputValue = null,
  label: propsLabel = null,
  isDownloadAvailable = true,
  isOneArtifact = false,
}) => {
  const { data } = useShowContext();

  const { getArtifactsDataByIds } = useArtifactService({ isCandidateService: true });
  const { download } = useArtifactDownloadHelper({ isCandidateService: true });
  const attachmentsIds = (data && data.getValueBySource('lastUploadedResumeIds')) || [];

  const attachments = useAsyncValue(async () =>
    getArtifactsDataByIds(isOneArtifact ? [attachmentsIds] : attachmentsIds),
  );

  const onDownloadClickHandler = async (fileId: number | string, fileTitle?: string | undefined) => {
    await download(fileId, fileTitle);
  };

  if (!!attachments && attachments.length > 0) {
    const file = attachments[attachments.length - 1];
    const { id, title } = file;
    const elementId = `view-preview-button-${id}`;
    const handleClick = () => onDownloadClickHandler(id, title);
    const customFileName = 'Resume';
    return (
      <Box
        component="button"
        key={id}
        type="button"
        onClick={handleClick}
        id={elementId}
        data-testid="artifact-open-preview"
        sx={{
          backgroundColor: 'primary.main',
          display: 'flex',
          flexDirection: 'row',
          gap: '5px',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'common.white',
          borderRadius: '3px',
          lineHeight: '22.4px',
          border: 0,
          fontSize: '14px',
          '&:active': {
            backgroundColor: 'primary.dark',
            color: 'common.white',
          },
        }}
      >
        {customFileName || <FileName title={title} />}
        <DownloadIcon sx={{ width: '21px', height: '15px' }} />
      </Box>
    );
  }
  return null;
};

export default CandidateResumeBadge;
